import styled from 'styled-components';
import { NavLink } from 'react-router-dom';


import { WithThemeProps } from '../../../styles';

type LinkProps = {} & WithThemeProps

const Root = styled.div`
	position: relative;
	width: 100%;
	background-color: transparent;
`;

const LinkStyled = styled(NavLink)`
	position: relative;
	z-index: 1;
	display: block;
	width: 100%;
	height: auto;
	min-height: 90px;
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
	color: #fff;
	transition: all .2s ease-in-out;
	text-decoration: none;

	&:hover {
		box-shadow: 0 1px 50px 0 rgba(0, 0, 0, 0.25);
		z-index: 2;
		text-decoration: none !important;
	}

	&:hover span {
		color: #fff;
	}

	&.active {
		box-shadow: 0 1px 50px 0 rgba(0, 0, 0, 0.25);
		z-index: 2;
	}

	&.active span {
		color: #fff;
	}

	& .menu-services-fill-content {
		transition: all .2s ease-in-out;
	}

	${(p: LinkProps) => p.theme && `
		background-color: ${p.theme.color.bgDark};

		&:hover .menu-services-fill-content {
			fill: ${p.theme.color.accentPrimary};
			fill-opacity: 1;
		}
	
		&.active .menu-services-fill-content {
			fill: ${p.theme.color.accentPrimary};
			fill-opacity: 1;
		}

		&:hover .menu-services-stroke-content {
			fill: ${p.theme.color.accentPrimary};
			fill-opacity: 1;
			stroke: ${p.theme.color.accentPrimary};
			stroke-opacity: 1;
		}
	
		&.active .menu-services-stroke-content {
			fill: ${p.theme.color.accentPrimary};
			fill-opacity: 1;
			stroke: ${p.theme.color.accentPrimary};
			stroke-opacity: 1;
		}
	`}
`;

const Name = styled.span`
	width: 100%;
	color: #fff;
	margin-top: 8px;
	color: rgba(255, 255, 255, 0.4);
	transition: color .2s ease-in-out;
	text-align: center;
	font-size: 12px;
	line-height: 1.25;
`;


export {
	Root,
	LinkStyled,
	Name
};
